export default {
  path: '/payment',
  component: () => import('@/components/home.vue'),
  children: [
    {
      path: 'paymentApplyList',
      name: 'paymentApplyList',
      component: () => import('@/pages/financeCenter/payment/index.vue'),
      meta: {
        keepAlive: true,
        title: '付款申请单查询',
      },
    },
    {
      path: 'paymentApplyAdd',
      name: 'paymentApplyAdd',
      component: () => import('@/pages/financeCenter/payment/paymentApply/add.vue'),
      meta: {
        keepAlive: true,
        title: '付款申请单创建',
      },
    },
    {
      path: 'paymentApplyEdit',
      name: 'paymentApplyEdit',
      component: () => import('@/pages/financeCenter/payment/paymentApply/edit.vue'),
      meta: {
        keepAlive: true,
        title: '付款申请单编辑',
      },
    },
    {
      path: 'paymentApplyDetail',
      name: 'paymentApplyDetail',
      component: () => import('@/pages/financeCenter/payment/paymentApply/details.vue'),
      meta: {
        keepAlive: true,
        title: '付款申请单详情',
      },
    },
    {
      path: 'paymentList',
      name: 'paymentList',
      component: () => import('@/pages/financeCenter/payment/paymentOrder/list.vue'),
      meta: {
        keepAlive: true,
        title: '付款单查询',
      },
    },
    {
      path: 'paymentAdd',
      name: 'paymentAdd',
      component: () => import('@/pages/financeCenter/payment/paymentOrder/add.vue'),
      meta: {
        keepAlive: true,
        title: '付款单创建',
      },
    },
    {
      path: 'paymentEdit',
      name: 'paymentEdit',
      component: () => import('@/pages/financeCenter/payment/paymentOrder/edit.vue'),
      meta: {
        keepAlive: true,
        title: '付款单编辑',
      },
    },
    {
      path: 'paymentDetails',
      name: 'paymentDetails',
      component: () => import('@/pages/financeCenter/payment/paymentOrder/details.vue'),
      meta: {
        keepAlive: true,
        title: '付款单详情',
      },
    },
    {
      path: 'paymentApply',
      name: 'paymentApply',
      component: () => import('@/pages/financeCenter/payment/index.vue'),
      meta: {
        keepAlive: true,
        title: '付款申请单查询',
      },
    },
    // {
    //   path: 'paymentApplyAddCk',
    //   name: 'paymentApplyAddCk',
    //   component: () => import('@/pages/financeCenter/payment/chengKuangApply/add.vue'),
    //   meta: {
    //     keepAlive: true,
    //     title: '付款申请单创建',
    //   },
    // },
    {
      path: 'paymentApplyEditCK',
      name: 'paymentApplyEditCK',
      component: () => import('@/pages/financeCenter/payment/chengKuangApply/edit.vue'),
      meta: {
        keepAlive: true,
        title: '付款申请单编辑',
      },
    },
    {
      path: 'paymentApplyDetailCK',
      name: 'paymentApplyDetailCK',
      component: () => import('@/pages/financeCenter/payment/chengKuangApply/details.vue'),
      meta: {
        keepAlive: true,
        title: '付款申请单详情',
      },
    },
    {
      path: 'applyAddCK',
      name: 'applyAddCK',
      component: () => import('@/pages/financeCenter/payment/chengKuangApply/add.vue'),
      meta: {
        keepAlive: true,
        title: '付款申请单创建',
      },
    },
  ],
};
